export default "__VITE_ASSET__504a0ad8__"